<template>
	<div>
		<el-drawer
			:title="calcConf.title"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:size="width"
			:before-close="() => batchCancelUpload('关闭')"
			:wrapperClosable="false"
			custom-class="drawer-template"
		>
			<div class="upload-content">
				<el-upload
					class="upload-demo"
					drag
					action="#"
					:accept="calcConf.accept"
					:auto-upload="false"
					:on-change="beforeUploadHandle"
					multiple
					:show-file-list="false"
				>
					<i class="el-icon-upload"></i>
					<div class="upload-btn">上传{{ calcConf.desc }}</div>
					<slot name="tip">
						<template v-if="type === 'video'">
							<p>横版: 格式：mp4,mov, 宽高比16: 9，视频码率≥516kbps, 大小≤200M, 2560*1440≥分辨率≥1280*720,300s≥时长≥4s</p>
							<p>竖版: 格式：mp4,mov, 宽高比9: 16，视频码率≥516kbps, 大小≤200M, 1440*2560≥分辨率≥720*1280,300s≥时长≥4s</p>
						</template>
						<template v-if="type === 'picture'">
							<p style="width: 508px; margin: auto">
								支持JPG、PNG等图片格式，建议最佳: 宽高16:9，2560*1440≥尺寸≥1280*720 或 宽高9:16. 2160*3840≥尺寸≥1080*1920，文件大小≤200M
							</p>
						</template>
					</slot>
				</el-upload>
				<!-- 弹窗内容部分 -->
				<div class="table-content mt-12">
					<div class="upload-info">
						<div class="left">
							<span class="ml-12">上传成功文件数：</span>
							<span class="">{{ filterCount(FILE_STATUS.SUCCESS) }}</span>
							<span class="ml-16">上传失败文件数：</span>
							<span>{{ filterCount(FILE_STATUS.FAIL) }}</span>
						</div>
						<div class="right mr-12">剩余储存空间：{{ leftSize }}</div>
					</div>
					<div class="table-container">
						<el-table :data="list" class="table-small" height="100%">
							<el-table-column label="文件名" min-width="100px">
								<template slot-scope="{ row }">
									<div class="info-wrapper">
										<el-image style="width: 32px; height: 40px; border-radius: 4px" fit="cover" :src="row.img">
											<template v-slot:placeholder>
												<img style="width: 32px; height: 40px" src="@/assets/public/empty_ranking.png" alt="" />
											</template>
											<template v-slot:error>
												<img style="width: 32px; height: 40px" src="@/assets/public/empty-error.png" alt="" />
											</template>
										</el-image>
										<div class="info-content">
											<rd-text class="file-name">{{ row.fileName }}</rd-text>
											<div class="msg flex-align-center" v-show="calcMsgConf(row).msg" :style="{ color: calcMsgConf(row).color }">
												<img class="mr-4" style="width: 20px; height: 20px" :src="calcMsgConf(row).icon" alt="" />
												{{ calcMsgConf(row).msg }}
											</div>
										</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="标签" width="150px">
								<template slot-scope="{ row }">
									<div class="info-wrapper mt-20" v-auth="['addTag:local-material']" v-if="row.fileStatus === FILE_STATUS.SUCCESS">
										<rd-tag-group
											:useByTable="false"
											:list="(row.tagList && row.tagList.map(item => item.tagName)) || []"
											:max="2"
											:type="2"
											@edit="() => editTags(row)"
										></rd-tag-group>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="大小" width="100px">
								<template slot-scope="{ row }">{{ calcSize(row) }}</template>
							</el-table-column>
							<el-table-column label="操作" width="150px" fixed="right" align="right" prop="operates">
								<template slot-scope="{ row, $index }">
									<el-button
										v-if="[FILE_STATUS.CANCE, FILE_STATUS.WARN_DURATION, FILE_STATUS.WARN_VIDEO_RADIO, FILE_STATUS.FAIL].includes(row.fileStatus)"
										type="text"
										class="fz-12"
										@click="debounceUpload(row)"
									>
										继续上传
									</el-button>
									<span
										class="line"
										v-else-if="
											row.fileStatus !== FILE_STATUS.UPLOADING &&
											row.fileStatus !== FILE_STATUS.SUCCESS &&
											row.fileStatus !== FILE_STATUS.TYPE_NOT_SUPPORT
										"
									></span>
									<el-button
										v-if="row.fileStatus !== FILE_STATUS.UPLOADING && row.fileStatus !== FILE_STATUS.SUCCESS"
										type="text"
										class="fz-12"
										@click="deleteFile($index)"
									>
										移除
									</el-button>
									<el-button v-else-if="row.fileStatus === FILE_STATUS.UPLOADING" type="text" class="fz-12" @click="cancelUpload(row)">
										取消上传
									</el-button>
									<span v-else>-</span>
								</template>
							</el-table-column>
							<empty slot="empty"></empty>
						</el-table>
					</div>
				</div>
			</div>

			<div class="drawer-footer">
				<el-button @click="() => batchCancelUpload('关闭')">关闭</el-button>
			</div>
		</el-drawer>
		<tagDialog ref="tagDialog" type="2" @refreshList="refreshList"></tagDialog>
	</div>
</template>
<script>
import { debounce } from 'lodash';
import MP4Box from 'mp4box';
import { getTagList } from '@/api/tagManagement';
import tagDialog from '@/components/business/tagDialog';
import Upload from '@/utils/uploadBigFileToOss.js';
import { getMaterialSource, batchSaveMaterial, checkStorageSpace } from '@/api/contentLibray.js';
import { FILE_STATUS } from './const';
import { uniqWith } from 'lodash';

const nanoid = require('nanoid');

const confMap = {
	video: {
		title: '添加视频素材',
		desc: '视频',
		accept: 'video/mp4, video/quicktime',
	},
	picture: {
		title: '添加图片素材',
		desc: '图片',
		accept: 'image/png,image/jpeg',
	},
};
export default {
	props: {
		type: {
			type: String,
			default: 'picture',
		},
	},
	data() {
		return {
			FILE_STATUS,
			visible: false, // 弹窗显隐
			list: [], // 列表数据
			loading: false, // 表格加载状态
			appendToBody: true,
			size: 'normal',
			leftSize: 0,
		};
	},
	computed: {
		isVideo() {
			return this.type === 'video';
		},
		isPicture() {
			return this.type === 'picture';
		},
		calcConf() {
			return confMap[this.type];
		},
		isSafari() {
			return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		},
		// 弹窗尺寸转换为实际px值
		width() {
			return dataMap.DRAWER_SIZE_WIDTH[this.size];
		},
		// 计算某个状态文件数量
		filterCount() {
			return status => {
				return this.list.filter(item => item.fileStatus === status).length;
			};
		},
		// 提示信息
		calcMsgConf() {
			const { ERROR_SIZE, NOT_ENOUGH_SPACE, NAME_TOO_LONG, WARN_DURATION, WARN_VIDEO_RADIO, CANCEL, TYPE_NOT_SUPPORT, NAME_REPETITION } = FILE_STATUS;
			return ({ fileStatus, validMsg, progress, uploadErrorMsg }) => {
				if ([ERROR_SIZE, NOT_ENOUGH_SPACE, NAME_TOO_LONG, TYPE_NOT_SUPPORT, NAME_REPETITION].includes(fileStatus)) {
					return {
						icon: require('@/assets/public/close-circle-line.png'),
						msg: validMsg,
						color: '#FA2714',
					};
				} else if (fileStatus === FILE_STATUS.UPLOADING) {
					return {
						icon: require('@/assets/public/upload-task-icon.png'),
						msg: `上传中... ${Math.floor(progress * 100) / 100}%`,
						color: '#2475ff',
					};
				} else if (fileStatus === FILE_STATUS.SUCCESS) {
					return {
						icon: require('@/assets/public/check-double-line.png'),
						msg: '上传成功',
						color: '#3DCC85',
					};
				} else if ([WARN_DURATION, WARN_VIDEO_RADIO, CANCEL].includes(fileStatus)) {
					return {
						icon: require('@/assets/public/warn-icon.png'),
						msg: validMsg,
						color: '#FF7038',
					};
				} else if (fileStatus === FILE_STATUS.FAIL) {
					return {
						icon: require('@/assets/public/close-circle-line.png'),
						msg: uploadErrorMsg,
						color: '#FA2714',
					};
				} else {
					return {
						icon: require('@/assets/public/rest-time-line.png'),
						msg: '等待上传',
						color: '#2475FF',
					};
				}
			};
		},
	},
	created() {
		this.updateLeftSize();
		window.addEventListener('beforeunload', this.beforeunload);
		setTimeout(() => {
			if (!(history.state && history.state.target == 'Final')) {
				window.history.pushState({ target: 'MeanSure', random: Math.random() }, '', location.href);
				window.history.pushState({ target: 'Final', random: Math.random() }, '', location.href);
			}
			window.addEventListener('popstate', this.handleHistoryBack, false);
		}, 500);
	},
	beforeDestroy() {
		window.removeEventListener('beforeunload', this.beforeunload);
		window.removeEventListener('popstate', this.handleHistoryBack);
	},
	methods: {
		calcSize(row) {
			const size = Math.floor((row.file.size / 1024 / 1024) * 100) / 100;
			if (size == 0) {
				return `${Math.floor((row.file.size / 1024) * 100) / 100}KB`;
			} else {
				return size + 'MB';
			}
		},
		// 执行浏览器回退
		back() {
			let backCount = history.state.target == 'Final' ? -4 : -2;
			history.go(backCount);
		},
		// 停留当前页面
		stay() {
			history.forward();
		},
		handleHistoryBack() {
			this.batchCancelUpload('离开当前上传页面', true);
		},
		// 页面更新/关闭回调
		beforeunload(event) {
			if (this.filterCount(FILE_STATUS.UPLOADING) > 0) {
				// Cancel the event as stated by the standard.
				event.preventDefault();
				// Chrome requires returnValue to be set.
				event.returnValue = '';
			}
		},
		// 添加标签成功回调
		async refreshList(ids) {
			let selectAll = [];
			const {
				data: { list = [] },
			} = await getTagList({ page_size: 100, page_index: 1, appType: 1, tagName: '' });
			list.map(val => {
				if (ids.includes(val.id)) {
					selectAll.push(val);
				}
			});
			this.list.map(val => {
				if (val.materialId == this.currentEdit.materialId) {
					val.tagList = uniqWith(JSON.parse(JSON.stringify(selectAll)), (a, b) => a.id == b.id);
				}
			});
		},
		// 编辑标签
		editTags(row) {
			this.currentEdit = row;
			this.$refs.tagDialog.show('编辑标签', [row]);
		},
		// 移除文件
		deleteFile(index) {
			this.list.splice(index, 1);
		},
		// 获取剩余存储空间
		async getLeftSize() {
			const { materialAvailableSize } = await getMaterialSource();
			return materialAvailableSize;
		},
		// 更新剩余存储空间
		async updateLeftSize() {
			const { materialAvailableSize } = await getMaterialSource();
			this.leftSize = materialAvailableSize;
		},
		// 批量取消
		batchCancelUpload(msg = '关闭', isHistoryBack) {
			if (this.filterCount(FILE_STATUS.UPLOADING) > 0) {
				this.$confirm(`${msg}将清空本次所有正在上传的素材，确定${msg}吗？`, `确认取消所有上传${confMap[this.type].desc}`, {
					confirmButtonText: `确认${msg}`,
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						this.list.forEach(item => {
							if (item.fileStatus === FILE_STATUS.UPLOADING) {
								item.uploadInstance.cancel();
							}
						});
						this.handleClose();
						isHistoryBack && this.back();
					})
					.catch(() => {
						isHistoryBack && this.stay();
					});
			} else {
				this.handleClose();
				isHistoryBack && this.back();
			}
		},
		// 单个取消
		cancelUpload(row) {
			this.$confirm('取消将清空本次上传的素材，确定取消吗？', `确认取消上传${confMap[this.type].desc}`, {
				confirmButtonText: '确认取消',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				row.uploadInstance.cancel();
				row.validMsg = '已取消上传';
				row.fileStatus = FILE_STATUS.CANCEL;
			});
		},
		/**
		 * 上传前回调
		 * @param {File} file 待上传文件
		 */
		async beforeUploadHandle(file) {
			const fileData = await this.transformData(file);
			this.list.push(fileData);
			this.checkFile(fileData);
			// this.startUpload(fileData);
		},
		/**
		 * 格式化封装上传文件信息
		 * @param {File} file 待上传文件
		 */
		async transformData(file) {
			try {
				const { name, size, type } = file.raw;
				let videoinfo = {};
				let isSupportMP4 = true;
				const isMP4 = type.indexOf('video/mp4') > -1;
				let isSupportType = this.calcConf.accept.indexOf(type) > -1;
				// 如果是mp4需要校验编码，其他格式mov无法校验
				if (isMP4) {
					videoinfo = await this.checkVideoCode(file.raw);
					// 格式支持，并且如果是mp4编码也要支持
					isSupportMP4 = ['avc', 'hvc'].some(type => videoinfo.mime.indexOf(type) > -1);
					// isSupportMP4 = 'MediaSource' in window ? MediaSource.isTypeSupported(videoinfo.mime) && isSupportMP4 : isSupportMP4;
				}
				// console.log(isSupportType, MediaSource.isTypeSupported(videoinfo.mime), 888, videoinfo, isSupportMP4);
				// 兼容windows可以选择文件类型问题
				if (!isSupportType || !isSupportMP4) {
					return {
						fileName: name,
						validMsg: this.isVideo ? '仅支持上传编码为avc、hvc的mp4、mov的格式视频' : '仅支持上传png、jpeg格式图片',
						fileStatus: FILE_STATUS.TYPE_NOT_SUPPORT,
						img: null,
						file: file.raw,
						duration: 0,
						fcpFile: null,
						progress: 0,
						tagList: [],
					};
				}
				const res = await (this.type === 'picture' ? this.getImageInfo(file.raw) : this.getVideInfo(file.raw));
				const { msg, status } = await this.validate({
					...res,
					size,
					type,
					name,
				});
				const blobFile = this.isVideo && this.dataURLtoBlob(res.dataURL);
				// 解析失败，置为c端pc会做兜底图展示
				const fcpFile = this.isPicture || !blobFile ? null : this.blobToFile(blobFile, file.name + '-' + nanoid.nanoid(16) + '.jpeg');
				let retData = {
					fileName: name,
					validMsg: msg,
					fileStatus: status,
					img: res.dataURL,
					file: file.raw,
					duration: res.duration,
					fcpFile: fcpFile,
					progress: 0,
					tagList: [],
				};

				return retData;
			} catch (error) {
				// console.log(error);
			}
		},
		/**
		 * 校验上传文件信息
		 * @param {object} param0 待校验信息
		 */
		async validate({ duration, width, height, size, name }) {
			const leftSize = await this.getLeftSize();
			if (name.length > 50) {
				return {
					msg: '文件名称最长支持50字，请修改',
					status: FILE_STATUS.NAME_TOO_LONG,
				};
			}
			if (Number(size) / 1024 > Number(leftSize)) {
				return {
					msg: '储存空间不足，请选择文件移除',
					status: FILE_STATUS.NOT_ENOUGH_SPACE,
				};
			}
			if (Number(size) > 200 * 1024 * 1024) {
				return {
					msg: '大于200M无法上传，请移除',
					status: FILE_STATUS.ERROR_SIZE,
				};
			}
			if (this.type === 'video' && Number(duration) < 4) {
				return {
					msg: '时长过短 <4s，请确认是否继续上传',
					status: FILE_STATUS.WARN_DURATION,
				};
			}
			if (width / height !== 16 / 9 && width / height !== 9 / 16) {
				return {
					msg: `${this.calcConf.desc}尺寸不符合规范，建议裁剪优化`,
					status: FILE_STATUS.WARN_VIDEO_RADIO,
				};
			}
			return {
				status: FILE_STATUS.IS_WAITING,
			};
		},
		/**
		 * 获取解析的图片信息
		 * @param {File} file 图片文件
		 */
		getImageInfo(file) {
			return new Promise(function (resolve) {
				// 获取上传的图片的宽高
				var imageObj = new Image();
				const imgSrc = URL.createObjectURL(file);
				imageObj.src = imgSrc;
				imageObj.onload = function () {
					// console.log(imageObj.width + imageObj.height);
					// 执行上传的方法，获取外网路径，上传进度等
					resolve({
						height: imageObj.height,
						width: imageObj.width,
						dataURL: imgSrc,
					});
				};
			});
		},
		/**
		 * 获取解析的视频信息
		 * @param {File} file 视频file
		 */
		getVideInfo(file) {
			const that = this;
			return new Promise(function (resolve, reject) {
				try {
					let dataURL = undefined;
					let videoElement = document.createElement('video');
					videoElement.setAttribute('crossOrigin', 'anonymous'); //处理跨域
					videoElement.setAttribute('muted', 'muted');
					videoElement.setAttribute('src', URL.createObjectURL(file));
					videoElement.setAttribute('width', 160);
					videoElement.setAttribute('autoplay', 'autoplay');
					videoElement.setAttribute('preload', 'preload');
					videoElement.setAttribute('height', 200);
					// videoElement.currentTime = 1; //指定帧数

					if (!that.isSafari) {
						videoElement.pause(); // 通过暂停关闭声音 muted不生效
					}
					// 获取视频信息
					videoElement.addEventListener('loadedmetadata', function () {
						// console.log('loadedmetadata', videoElement.duration, dataURL);
						// 保证  dataURL  duration 均有值
						if (dataURL) {
							// console.log('loadedmetadata', videoElement.duration, dataURL);
							resolve({
								duration: videoElement.duration,
								width: videoElement.videoWidth,
								height: videoElement.videoHeight,
								dataURL,
							});
							that.removeVideo(videoElement);
						}
					});
					// 获取首帧
					videoElement.addEventListener('loadeddata', function () {
						// console.log('loadeddata', videoElement.duration, dataURL);
						clearTimeout(that[file.uid]);
						// safari 处理黑屏问题
						// console.log('isSafari', that.isSafari, navigator.userAgent);
						if (!that.isSafari) {
							const res = that.handleVideoInfo(videoElement);
							resolve(res);
							that.removeVideo(videoElement);
						} else {
							that[file.uid] = setTimeout(() => {
								const res = that.handleVideoInfo(videoElement);
								resolve(res);
								that.removeVideo(videoElement);
							}, 500);
						}
					});
				} catch (error) {
					// console.log(error);
				}
			});
		},
		handleVideoInfo(videoElement) {
			// console.log('===handleVideoInfo====');
			let dataURL = undefined;
			let canvas = document.createElement('canvas');
			canvas.width = videoElement.videoWidth;
			canvas.height = videoElement.videoHeight;
			canvas.getContext('2d').drawImage(videoElement, 0, 0, videoElement.videoWidth, videoElement.videoHeight); //绘制canvas
			dataURL = canvas.toDataURL('image/jpeg'); //转换为base64
			// 保证 duration dataURL 均有值
			if (videoElement.duration) {
				// console.log('loadeddata', videoElement.duration, dataURL);
				return {
					duration: videoElement.duration,
					width: videoElement.videoWidth,
					height: videoElement.videoHeight,
					dataURL,
				};
			}
		},
		// 删除video
		removeVideo(videoElement) {
			// console.log('===removeVideo====');
			// videoElement.pause();
			// videoElement.removeAttribute('src'); // empty source
			// videoElement.load();
		},
		// 将base64转换为blob
		dataURLtoBlob(dataurl) {
			try {
				let arr = dataurl.split(','),
					mime = arr[0]?.match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], { type: mime });
			} catch (error) {
				// console.log('==dataURLtoBlob===error==', error);
				return null;
			}
		},
		// 将blob转换为file
		blobToFile(theBlob, fileName) {
			theBlob.lastModifiedDate = new Date();
			theBlob.name = fileName;
			return theBlob;
		},
		debounceUpload: debounce(function (val) {
			if ([FILE_STATUS.CANCEL, FILE_STATUS.WARN_DURATION, FILE_STATUS.WARN_VIDEO_RADIO, FILE_STATUS.FAIL].includes(val.fileStatus)) {
				val.fileStatus = FILE_STATUS.IS_WAITING;
			}
			this.startUpload(val);
		}, 500),
		/**
		 * 上传的校验可用空间/文件文字是否重复
		 */
		async checkFile(info) {
			let isVideo = this.type === 'video';
			const data = await checkStorageSpace({
				materialSizeList: [
					{
						materialSize: Math.ceil((info.file.size / 1024) * 100) / 100,
						materialType: isVideo ? 1 : 0,
						title: info.file.name.split('.').slice(0, -1).join(),
					},
				],
			});
			// console.log(this.list, 'list');
			if (data.success) {
				this.startUpload(info);
			} else {
				this.list.map(val => {
					// console.log(val, val.file.uid === info.file.uid);
					if (val.file.uid === info.file.uid) {
						val.validMsg = data.msg;
						val.fileStatus = data.code === 101 ? 'NAME_REPETITION' : 'NOT_ENOUGH_SPACE';
					}
				});
			}
		},

		/**
		 * 开始上传oss
		 * @param {object} item 待上传数据项
		 */
		async startUpload(item) {
			// console.log(item, '====startUpload===');
			try {
				// 已经上传完成无需再传
				if (item.progress === 100 || item.fileStatus !== FILE_STATUS.IS_WAITING) return;
				// 获取upload工具类实例
				item.uploadInstance = await this.getOssClient();
				item.uploadInstance
					.upload(item.file, {
						progressCb: p => {
							item.progress = p;
							item.fileStatus = FILE_STATUS.UPLOADING;
							// console.log('当前进度', p);
						},
					})
					.then(async res => {
						if (this.type === 'video') {
							const fcpRes = item.fcpFile && (await this.uploadFcpFile(item));
							const fcpUrl = fcpRes?.name;
							const materialId = await this.addVideo(res.name, fcpUrl, item);
							item.materialId = materialId;
							// console.log('视频上传成功', res, fcpRes, fcpUrl, 6666, materialId);
						} else {
							const materialId = await this.addPic(res.name, item.file);
							item.materialId = materialId;
							// console.log('图片上传成功', res, 6666, materialId);
						}
						item.fileStatus = FILE_STATUS.SUCCESS;
						item.uploadInstance = null;
						this.updateLeftSize();
					})
					.catch(e => {
						item.uploadErrorMsg = e.message;
						item.fileStatus = FILE_STATUS.FAIL;
					});
			} catch (error) {
				// console.log('===startUpload====try catch', error);
			}
		},
		// https://www.jianshu.com/p/06696f7cd6d6
		checkVideoCode(file) {
			return new Promise((resolve, reject) => {
				const mp4boxFile = MP4Box.createFile();
				const reader = new FileReader();
				reader.readAsArrayBuffer(file);
				reader.onload = function (e) {
					const arrayBuffer = e.target.result;
					arrayBuffer.fileStart = 0;
					mp4boxFile.appendBuffer(arrayBuffer);
				};
				mp4boxFile.onReady = function (info) {
					resolve(info);
				};
				mp4boxFile.onError = function (info) {
					reject(info);
				};
			});
		},
		/**
		 * 上传视频首帧截图文件
		 * @param {object} item 文件格式化对象
		 * @return {Promise} 上传成功oss回调
		 */
		uploadFcpFile(item) {
			return new Promise((resolve, reject) => {
				item.uploadInstance
					.commonUpload(item.fcpFile, `picture/${process.env.VUE_APP_ENV}/${this.$store.state.vuex_tenantId}/` + item.fcpFile.name)
					.then(res => {
						resolve(res);
					})
					.catch(e => {
						// console.log(e);
						// 上传出现异常，首帧传控，后端做首帧图片兜底，即使异常也要resolve保证后面步骤执行下去
						resolve({});
					});
			});
		},

		// 主动显示弹窗
		show() {
			this.updateLeftSize();
			this.visible = true;
		},
		/**
		 * 文件oss上传成功后，同步后端上传图片信息
		 * @param {string} bucketPath 上传图片资源oss路径
		 * @param {obejct} param2 文件格式对象
		 */
		async addPic(bucketPath, { size, name, type }) {
			const { data, code } = await batchSaveMaterial({
				materialList: [
					{
						title: name.split('.').slice(0, -1).join(),
						link: bucketPath,
						coverUrl: '',
						materialSize: Math.ceil((size / 1024) * 100) / 100,
						fileType: type.split('/')[1],
						unit: 'KB',
						materialType: 2,
						videoDuration: 0,
					},
				],
			});
			if (code !== 0) {
				return Promise.reject(new Error('上传失败'));
			}
			return data[0]?.id || '';
		},
		/**
		 * 文件oss上传成功后，同步后端上传视频信息
		 * @param {string} bucketPath 上传视频资源oss路径
		 * @param {string} fcpUrl 视频封面图片 oss路径
		 * @param {obejct} param2 文件格式对象
		 */
		async addVideo(bucketPath, fcpUrl, { duration, file }) {
			const { size, name, type } = file;
			const { code, data } = await batchSaveMaterial({
				materialList: [
					{
						title: name.split('.').slice(0, -1).join('.'),
						link: bucketPath,
						materialSize: Math.ceil((size / 1024) * 100) / 100,
						coverUrl: fcpUrl,
						unit: 'KB',
						materialType: 1,
						videoDuration: duration,
						fileType: type.split('/')[1] === 'quicktime' ? 'mov' : type.split('/')[1],
					},
				],
			});
			if (code !== 0) {
				return Promise.reject(new Error('上传失败'));
			}
			return data[0]?.id || '';
		},
		// 清空数据并关闭弹窗
		handleClose() {
			// 清空数据
			this.list = [];
			// 关闭弹窗
			this.visible = false;
			this.$emit('close');
		},
		// 每页展示条数变化
		// 不需要响应式的数据进行初始化设置
		async getOssClient() {
			const uploadInstance = new Upload({
				bucketPath: `${this.type}/${process.env.VUE_APP_ENV}/${this.$store.state.vuex_tenantId}/`,
			});
			// 工具upload类构造函器不许使用await
			await uploadInstance.initOssClient();
			return uploadInstance;
		},
	},
	components: { tagDialog },
};
</script>

<style lang="less" scoped>
.drawer-footer {
	background-color: #fff;
}

span.line {
	width: 1px;
	height: 8px;
	margin: 0 8px;
	display: inline-block;
	/* Border/light */
	background: #eaebf0;
}

.msg {
	display: flex;
	align-items: flex-start;
	line-height: 1.3;
}

.upload-info {
	background-color: #fff;
	display: flex;
	justify-content: space-between;
	font-family: PingFangSC-Regular;
	font-size: 12px;
	font-weight: normal;
	line-height: 20px;
	padding-bottom: 16px;
	border-bottom: 1px solid #f0f1f5;
	/* 超/灰/G8 */
	color: #4e596a;

	.left {
		span {
			&:nth-child(2) {
				font-family: PingFangSC-Semibold;
				color: #3dcc85;
			}

			&:nth-child(4) {
				font-family: PingFangSC-Semibold;
				color: #fa2714;
			}
		}
	}

	.right {
	}
}

.table-container {
	flex: 1;
}

.table-content {
	border-radius: 8px;
	overflow: hidden;
	padding: 16px;
	background-color: #fff;
	flex: 1;
	flex-direction: column;
	display: flex;
	margin-bottom: 20px;
}

/deep/ .drawer-template {
	.el-drawer__body {
		padding: 20px 20px 53px !important;
		background-color: #f7f8fa;
	}
}

.upload-content {
	height: 100%;
	display: flex;
	flex-direction: column;
}

/deep/ .el-upload {
	&:hover {
		.el-upload-dragger {
			transition: 0.3s linear;
			border: 1px solid @color-primary;

			.upload-btn {
				color: @color-primary;
			}
		}
	}

	display: flex;

	.upload-btn {
		font-family: PingFangSC-Semibold;
		font-size: 14px;
		font-weight: normal;
		line-height: 24px;
		/* Font/text-primary */
		color: @color-text-primary;
	}

	.el-upload-dragger {
		flex: 1;
		border-radius: 8px;
		border: 1px solid #fff;

		.el-icon-upload {
			line-height: 44px;
			font-size: 44px;
			margin: 33px 0 16px;
		}
	}

	p {
		font-family: PingFangSC-Regular;
		font-size: 12px;
		font-weight: normal;
		line-height: 20px;
		/* Font/text-secondary */
		color: #86909d;
	}
}

.el-icon-upload {
	color: @color-primary !important;
}

.info-wrapper {
	.info-content {
		width: 248px;
	}

	.el-image {
		flex-shrink: 0;
		margin-right: 12px;
	}

	display: flex;
}
/deep/ .el-table::before {
	display: none !important;
}
/deep/ .el-table__fixed-right {
	display: none !important;
}
</style>
